// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__6qXMv","footerContent":"footer_footerContent__LkCDa","divider":"footer_divider__qx1e-","storeName":"footer_storeName__N74gB"};